module.exports = __webpack_public_path__ + "static/media/whisper-img.ab91343b.png";